import api from 'utils/api';

export const updateReferrerSettingsApi = (settings) =>
	api.put('/referrer/me', settings);

export const fetchReferrerSettingsApi = () =>
	api.get('/referrer/me/settings');
